import { IconsEnum } from "../../enums/icon.enum";

export const footer = [
    {name: '+27 (11) 923 3500', route: 'tel:+27119233500', icon: IconsEnum.PHONE},
    {name: 'ilease@avis.co.za', route: 'mailto:ilease@avis.co.za', icon: IconsEnum.EMAIL},  
]